<template>
  <div class="container">
    <!-- header -->
    <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft" class="navbar" />
    <!-- search -->
    <van-search placeholder="请输入搜索关键词" class="search fixed" @search="onSearch" v-model="keyword" />
    <!-- body -->
    <van-row class="table-header fixed">
      <van-col span="15">名称</van-col>
      <van-col span="9">操作</van-col>
    </van-row>
    <div class="content-scroll-list-wrap table-header-navbar footernavbar" ref="scrollWrapper">
      <cube-scroll
        ref="contentScroll"
        :data="list"
        :options="options"
        @pulling-up="onPullingUp"
        @pulling-down="onPullingDown"
      >
        <div class="nodata" v-if="!list.length">没有到任何数据!</div>
        <van-row
          :class="item.id===currId ? 'table-list-data on' : 'table-list-data' "
          v-for="(item,index) in list"
        >
          <van-col span="15">{{item.title}}</van-col>
          <van-col span="9">
            <van-icon name="add" size="22" @click="addToCart(item)" color="#2196f3" />
          </van-col>
        </van-row>
      </cube-scroll>
    </div>
    <!-- 购物车列表 -->
    <g-cart
      :open="isOpen"
      :list="cartList"
      :isUpdateModel="false"
      @close="onCloseCart"
      @remove="onRemoveCart"
      @changeNum="onChangeNum"
    />
    <!-- 底部导航栏 -->
    <div class="footer-navbar">
      <div class="footer-container">
        <div class="circle" @click="onOpenCart">
          <div class="info" v-if="!isCartEmpty">{{cartNum}}</div>
          <div :class="isCartEmpty ? 'cart-wrap' : 'cart-wrap active'">
            <van-icon
              name="cart"
              class="cart-icon"
              :color="isCartEmpty ? '#81838a' : '#fff' "
              size="30"
            />
          </div>
        </div>
        <van-button class="submit-btn" type="primary" :disabled="btnDisabled" @click="onSubmit">修改订单</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import GCart from "@/pages/home/order/components/cart";
import { OrderModel } from "@models/common/order";
import { CartModel } from "@models/common/cart";
import { ERR_OK } from "@/common";

const orderModel = new OrderModel();
const cartModel = new CartModel();
export default {
  data() {
    return {
      currId: 0,
      isOpen: false,
      keyword: "",
      title: "",
      list: [],
      options: {
        pullDownRefresh: {
          threshold: 60,
          stopTime: 1000,
          txt: "更新成功"
        },
        pullUpLoad: {
          txt: {
            noMore: "没有了"
          }
        }
      },
      cartList: [],
      modelCartList: [],
      totalpage: 1,
      page: 1,
      flag: false,
      cartNum: 0,
      isCartEmpty: true,
      btnDisabled: true
    };
  },
  components: {
    GCart
  },
  methods: {
    onClickLeft() {
      this.$redirect(`/admin/order/detail/${this.$route.params.id}`);
    },
    onSearch() {
      this.list = [];
      this.page = 1;
      this.get_list({
        keyword: this.keyword
      });
    },
    onOpenCart() {
      this.isOpen = true;
    },
    onCloseCart() {
      this.isOpen = false;
    },
    get_list(params = {}) {
      let obj = {
        user_token: localStorage.user_token,
        page: this.page
      };
      Object.assign(obj, params);
      orderModel.get_list(obj).then(res => {
        if (ERR_OK == res.code) {
          this.totalpage = res.data.last_page;
          this.list = this.list.concat(res.data.data);
          this.title = "(" + this.$route.query.merchname + ")" + "修改订单";
        }
      });
    },
    onPullingUp() {
      if (this.page < this.totalpage) {
        setTimeout(() => {
          this.page++;
          this.get_list();
        }, 1000);
      } else {
        this.$refs.contentScroll.forceUpdate();
      }
    },
    onPullingDown() {
      let params = {};
      setTimeout(() => {
        this.list = [];
        if (this.keyword) {
          params = {
            keyword: this.keyword
          };
        }
        this.get_list(params);
      }, 1000);
    },
    addToCart(data) {
      this.currId = data.id;
      let carts = [];
      //判断是否购物车中已经有商品，如果有就增加数量，反之加入这个商品
      let foodIndex = this.cartList.findIndex(item => item.id == data.id);
      //foodIndex为-1表示不存在 ,要加入商品
      if (foodIndex === -1) {
        this.cartList.push({
          id: data.id,
          title: data.title,
          num: 1
        });
        this.modelCartList.push({
          id: data.id,
          num: 1
        });
        //foodIndex存在 ,更新数据
      } else {
        this.cartList[foodIndex].num++;
        this.modelCartList[foodIndex].num++;
      }
      this.onSetCartNum(); //计算购物车数量
    },
    onSetCartNum() {
      this.countCartNum();
      if (this.cartList.length) {
        this.isCartEmpty = false; //购物车标记为不空
        this.btnDisabled = false; //提交按钮可用
      } else {
        this.isCartEmpty = true; //购物车标记为不空
        this.btnDisabled = true; //提交按钮可用
      }
    },
    //更新购物车数量
    onChangeNum(data = {}) {
      //更新购物里面添加的时候也要更新数量
      this.onSetCartNum();
      if (this.modelCartList.length) {
        this.modelCartList.forEach((item, index) => {
          if (item.id == data.item.id) {
            if (data.isremove) {
              this.modelCartList.splice(index, 1);
            } else {
              this.modelCartList.splice(index, 1, {
                id: data.item.id,
                num: data.item.num
              });
            }
          }
        });
      }
    },
    //清空购物车
    onRemoveCart(flag = false) {
      if (flag) {
        this.cartList = [];
        this.cartNum = 0;
        this.isCartEmpty = true;
        this.btnDisabled = true;
      } else {
        this.$dialog
          .confirm({
            title: "温馨提示",
            message: "确定要清空购物车?",
            cancelButtonText: "取消",
            confirmButtonText: "确定"
          })
          .then(res => {
            this.cartList = [];
            this.modelCartList = [];
            this.cartNum = 0;
            this.isCartEmpty = true;
            this.btnDisabled = true;
          })
          .catch(() => {});
      }
    },
    countCartNum() {
      //计算购物车数量
      this.cartNum = 0;
      if (this.cartList.length) {
        this.cartList.forEach(item => {
          this.cartNum += item.num;
        });
      }
    },
    onSubmit() {
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: "确定要修改订单?",
          cancelButtonText: "取消",
          confirmButtonText: "确定"
        })
        .then(res => {
          this.btnDisabled = true;
          orderModel
            .orderUpdate({
              orderid: this.$route.params.id,
              data: this.modelCartList,
              user_token: localStorage.user_token
            })
            .then(res => {
              if (res.code == ERR_OK) {
                this.$toast("修改订单成功!");
                setTimeout(() => {
                  this.$redirect(`/admin/order/detail/${this.$route.params.id}`);
                  this.btnDisabled = false;
                }, 3000);
              }
            });
        })
        .catch(() => {});
    },
    GetCartList() {
      orderModel
        .getOrderData2({
          id: this.$route.params.id,
        })
        .then(res => {
          this.cartList = res.data.data;
          if (res.data.data.length) {
            res.data.data.forEach((item, index) => {
              this.modelCartList.push({ id: item.id, num: item.num });
            });
          } else {
            this.modelCartList = [];
          }
          this.onSetCartNum(); //重新计算
        });
    }
  },
  created() {
    this.get_list();
    this.GetCartList();
  }
};
</script>

<style lang="stylus" scoped>
.container {
  background: #f2f3f5;
}

.table-list-data.on {
  background: #eee;
}

.scroll-wrap {
  height: calc(100% - 0.92rem);
  position: fixed;
  top: 0.92rem;
  width: 100%;
}

.footer-navbar {
  background: #141d26;
  border-top: none;
  z-index: 1004;
}

.circle {
  background: #141d26;
  border-radius: 50%;
  height: 1.4rem;
  width: 1.4rem;
  position: absolute;
  top: -0.5rem;
  left: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle .info {
  background: red;
  color: #fff;
  padding: 0.08rem 0.22rem;
  text-align: center;
  position: absolute;
  left: 0.8rem;
  top: -2px;
  box-shadow: 0px 3px 5px 0px #333;
  border-radius: 0.4rem;
}

.cart-wrap {
  background: #2b343b;
  height: 1.1rem;
  width: 1.1rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cart-wrap.active {
  background: #2196f3;
}

.cart-icon {
  position: relative;
}

>>>.submit-btn {
  height: 1rem;
  position: absolute;
  right: 0;
  top: 0;
}

>>>.van-button--disabled {
  background: #81838a;
  border-color: #81838a;
}

.navbar {
  color: #fff;
  background: #2196f3;
  position: fixed;
  top: 0;
  width: 100%;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

>>>.van-nav-bar__title, .van-nav-bar .van-icon, .van-nav-bar__text {
  color: #fff;
}

>>>.table-header {
  top: 2rem;
}

>>>.content-scroll-list-wrap.footernavbar {
  height: calc(100% - 0.92rem - 0.8rem - 0.92rem - 1.1rem);
}

>>> .content-scroll-list-wrap.table-header-navbar {
  top: 2.8rem;
}
</style>